module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/suppliers/suppliers-show/suppliers-show.component.scss
// module id = ./src/app/views/setting/suppliers/suppliers-show/suppliers-show.component.scss
// module chunks = main